import axios from 'axios';

$( document ).ready( function() {
	handleBookmark();
} );

function handleBookmark() {
	$( document ).on( 'click', '.toggle-bookmark', function() {
		if ( !ISDA_Main.partyId ) {
			window.location = '/my-account';
			return;
		}

		const postId = $( this ).data( 'post-id' );
		const element = $( this );
		const allBookmarkElements = $( `.toggle-bookmark[data-post-id="${ postId }"]` );
		const wasBookmarked = element.hasClass( 'fa-regular' );

		// Optimistically update UI
		const updateUI = ( isBookmarked ) => {
			if ( isBookmarked ) {
				allBookmarkElements.removeClass( 'fa-regular' )
				                   .addClass( 'fa' );
				ISDA_Main.userBookmarks.push( postId );
			} else {
				allBookmarkElements.removeClass( 'fa' )
				                   .addClass( 'fa-regular' );
				ISDA_Main.userBookmarks = ISDA_Main.userBookmarks.filter( id => id !== postId );
			}
		};

		// Apply optimistic update
		updateUI( wasBookmarked );

		// Make the API request
        console.log( wasBookmarked );
		axios.post( `${ wpApiSettings.root }isda/v1/account/bookmarks/`, {
			post_id: postId,
            add_bookmark: wasBookmarked
		}, getConfig() )
		     .then( function( response ) {
			     if ( response.data.status !== 'success' ) {
				     // Revert UI if server indicates failure
				     updateUI( !wasBookmarked );
				     console.error( 'Bookmark update failed:', response.data );
			     }
		     } )
		     .catch( function( error ) {
			     // Revert UI on request failure
			     updateUI( !wasBookmarked );
			     console.error( 'Bookmark request failed:', error );
		     } );
	} );
}

function getConfig() {
	return {
		headers: {
			'X-WP-Nonce': wpApiSettings.nonce
		}
	};
}